module.exports = __webpack_public_path__ + "img/credit.b3248ab.svg";